<section class="privacy-policy container pb-100">
  <div class="section-title-center text-center mb-5">
    <h1 class="fw-bold">🛡️ Politique de confidentialité</h1>
    <p>Chez <strong class="afrotech">AfroTech Hub</strong>, la confiance est au cœur de tout ce que nous construisons.</p>
    <p>Nous accordons autant d’importance à <strong>votre confidentialité</strong> qu’à <strong>l’innovation africaine</strong> que nous valorisons et défendons.</p>
  </div>

  <div class="policy-block">
    <h3>🔍 Les données que nous collectons</h3>
    <p>Lorsque vous interagissez avec notre plateforme (inscription à la newsletter, formulaire de contact,...), nous pouvons recueillir :</p>
    <ul>
      <li>Votre nom</li>
      <li>Votre adresse email</li>
      <li>Votre message ou commentaire</li>
    </ul>
    <p><em>Jamais de superflu, uniquement l’essentiel pour mieux vous servir.</em></p>
  </div>

  <div class="policy-block">
    <h3>🧠 Pourquoi nous collectons vos données</h3>
    <p>Vos données nous permettent de :</p>
    <ul>
      <li>Vous tenir informé(e) des dernières actualités Tech africaines</li>
      <li>Répondre à vos messages ou demandes</li>
      <li>Améliorer nos services et contenus</li>
    </ul>
    <p><em>Et surtout… <strong>jamais</strong> pour les revendre. Ce n’est pas notre vision de la tech.</em></p>
  </div>

  <div class="policy-block">
    <h3>🔐 Comment vos données sont protégées</h3>
    <p>Nous utilisons des outils fiables et chiffrons toutes les informations sensibles.</p>
    <p>Vos données sont stockées sur des serveurs sécurisés et gérées avec le plus grand soin.</p>
  </div>

  <div class="policy-block">
    <h3>🧭 Vos droits</h3>
    <ul>
      <li>Accéder à vos données</li>
      <li>Demander leur modification ou suppression</li>
      <li>Vous désinscrire de nos communications</li>
    </ul>
    <p><em>Il vous suffit d’un simple clic.</em></p>
  </div>

  <div class="policy-block">
    <h3>🤝 Transparence & respect</h3>
    <p><strong class="afrotech">AfroTech Hub</strong> s'engage à respecter la législation en vigueur sur la protection des données personnelles, notamment le Règlement Général sur la Protection des Données (RGPD).</p>
  </div>

  <div class="policy-block text-center">
    <h4>📬 Une question ?</h4>
    <p>Écrivez-nous à <a href="mailto:contact@afrotech-hub.com">contact@afrotech-hub.com</a></p>
    <p>Nous vous répondrons avec plaisir et respect.</p>
  </div>
</section>
